// Shim Stimulus pour bundles chargés après stimulus.js
// Évite la duplication du runtime (~30 KB) dans profiles.js
export const Controller = window.StimulusController
export const Application = window.StimulusApplication
